import { ref } from 'vue'
import { api } from '@/helpers/api'
import { useAuth } from '@/composables/auth/useAuth'

const URLS = {
    xhr: {
        mutate: {
            audio: '/api/profile/update-audio'
        }
    }
}
const musicPlayerStyles = {
    player: {
        'max-width': '100%'
    }
}

const audios = ref([])

export const useAudioUploader = () => {
    const { userValues, load } = useAuth()
    const audioUploadEl = ref(null)

    ;(() => _populateAudio())()

    function uploadAudio(e) {
        if (!e.target.files.length) return

        if (_checkForDuplicate(e.target.files[0])) {
            return
        }
        audios.value.push(e.target.files[0])
    }
    function handleUploadAudio() {
        audioUploadEl.value.click()
        audioUploadEl.value.value = ''
    }
    async function updateArtistAudio(data) {
        if (!data.length) return

        return await api({
            method: 'post',
            url: `${URLS.xhr.mutate.audio}/${userValues.value.id}`,
            data: _prepAudioData(data)
        })
    }
    async function updateAudioTitle(data) {
        try {
            load.value = true
            return await api({
                method: 'post',
                url: `${URLS.xhr.mutate.audio}/${userValues.value.id}`,
                data: {
                    _method: 'PUT',
                    ...data
                }
            })
        } finally {
            load.value = false
        }
    }
    async function deleteAudio(data) {
        try {
            load.value = true
            return await api({
                method: 'post',
                url: `${URLS.xhr.mutate.audio}/${userValues.value.id}`,
                data: {
                    _method: 'PUT',
                    delete_audios: data
                }
            })
        } finally {
            load.value = false
        }
    }

    function _populateAudio() {
        audios.value = userValues.value.audios
    }
    function _prepAudioData(data) {
        let formData = new FormData()
        let order = {}
        let orderName

        for (let i = 0; i < data.length; i++) {
            if (data[i] instanceof File) {
                orderName = data[i].name.split('.').slice(0, -1).join('.')
                formData.append('audios[]', data[i])
            } else {
                orderName = data[i].name_file
            }

            order = {
                ...order,
                [orderName]: i
            }
        }

        formData.append('order', JSON.stringify(order))
        formData.append('_method', 'PUT')

        return formData
    }
    function _checkForDuplicate(file) {
        for (let i = 0; i < audios.value.length; i++) {
            if (
                audios.value[i].name === file.name ||
                audios.value[i].name_file === file.name.substring(0, file.name.lastIndexOf('.'))
            ) {
                return true
            }
        }
        return false
    }
    return {
        musicPlayerStyles,
        audioUploadEl,
        audios,
        updateArtistAudio,
        uploadAudio,
        handleUploadAudio,
        deleteAudio,
        updateAudioTitle
    }
}
